module.exports = __webpack_public_path__ + "img/YAMAZAKI.660a0f59.svg";